var render, staticRenderFns
import script from "./BidCreatedModal.vue?vue&type=script&lang=js"
export * from "./BidCreatedModal.vue?vue&type=script&lang=js"
import style0 from "./BidCreatedModal.vue?vue&type=style&index=0&id=a60f2e40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports